import { TableCell, TableRow, Typography } from "@material-ui/core";
import { kebabCase } from "lodash";
import { useHistory } from "react-router-dom";
import { useTealium } from "@hubcapp/context";
import Button from "@ds-developer/button";
import React from "react";
const DetailsRow = ({
  title,
  children,
  text,
  action,
  disabled = false,
}: {
  title: string;
  children: React.ReactNode;
  text?: string;
  action?: string | (() => void);
  disabled?: boolean;
  onClick?: any;
}) => {
  const history = useHistory();
  const { trackEvent } = useTealium();
  const hasActionButton = text && action;
  const onButtonClick = () => {
    trackEvent({
      eventCategory: "View Learner - Edit Hourly Rate",
      eventAction: "Button Click",
      eventLabel: "Edit",
    });
    if (!hasActionButton || !action) {
      return;
    }
    if (typeof action === "string") {
      history.push(action);
    }
    if (typeof action === "function") {
      action();
    }
  };
  return (
    <TableRow>
      <TableCell>{title}</TableCell>
      <TableCell colSpan={hasActionButton ? 1 : 2}>
        <Typography
          variant="body2"
          data-test={`lesson-details-${kebabCase(title)}`}
        >
          {children}
        </Typography>
      </TableCell>
      {hasActionButton && (
        <TableCell align="right">
          <Button
            color="secondary"
            variant="outlined"
            size="small"
            title={`${text} ${title}`}
            onClick={onButtonClick}
            disabled={disabled}
          >
            {text}
          </Button>
        </TableCell>
      )}
    </TableRow>
  );
};
export default DetailsRow;
